import axios from 'axios';
import { systemOf } from '../constants/systems';

/**
 * Reply to a single-device command, as the test fixtures assume it.
 * Whether the backend can reply 2xx with `applied: false` is unconfirmed
 * (roadmap follow-up).
 * @typedef {Object} CommandReply
 * @property {string} mac
 * @property {boolean} [applied]
 */

/**
 * POST /{switches|blowers}/send-command. Components send through `useDeviceCommand`.
 * Blower systems (TGS, TES) carry their deviceType; ESS doesn't.
 * @param {'ess'|'tgs'|'tes'} system  a DEVICE_TYPES value works too
 * @param {string} deviceMac
 * @param {Object<string, number|string>} data  program keys, e.g. `{ on_switch: 1, instant_temp: 10 }` (°C), or a `faultResetPayload`
 * @returns {Promise<CommandReply>}
 */

export const sendCommand = async (system, deviceMac, data) => {
  const { resource, deviceType } = systemOf(system);
  const response = await axios.post(`/${resource}/send-command`, {
    mac: deviceMac,
    ...(resource === 'blowers' && { deviceType }),
    ...data,
  });
  return response.data?.data;
};
